import React, { useState } from 'react';

const LoginForm = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const validateUsername = (username) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(username).toLowerCase());
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!username || !password) {
            setError('Both fields are required');
            return;
        }
        if (!validateUsername(username)) {
            setError('Invalid username');
            return;
        }

        try {
            const response = await fetch('/authenticate.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ username, password }),
            });
            const result = await response.json();

            if (response.ok) {
                console.log('Login successful:', result);
                setError('');
            } else {
                setError(result.message || 'Login failed');
            }
        } catch (error) {
            setError('An error occurred. Please try again.');
        }
    };

    return (
        <>
            <div className="login-bg-video hidden-xs-down">
                <video className="bg-video" autoplay muted loop playsinline controlslist="nodownload" src="https://cdn-media.f-static.net/uploads/8636362/normal_6606719ccf492.mp4" />
                <div className="login-bg-grid"></div>
                <div className="login-bg-overlay"></div>
            </div>
            <div className="loginform-main-container">
                <div className="heptagon">
                    <div className="loginform-container">
                        <div className="loginform-top loginform-item">
                            <div className="loginform-intro">
                                <span>Member Login</span>
                                <span>CLite</span>
                            </div>
                        </div>
                        <div className="loginform-form loginform-item">
                            <div className="loginform-auth-label">Please authenticate yourself</div>
                            <form id="login-form" onSubmit={handleSubmit}>
                                {error && <div className="error">{error}</div>}
                                <div className="form-group">
                                    <input
                                        className="loginform-text-input"
                                        type="text"
                                        name="username"
                                        id="username"
                                        placeholder="Username"
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        className="loginform-text-input"
                                        type="password"
                                        name="password"
                                        id="user-password"
                                        placeholder="Password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </div>
                            </form>
                        </div>
                        <div className="loginform-bottom loginform-item">
                                <div className="loginform-submit-button">Login
                                </div>
                            <div className="loginform-links">
                                <span><a href="iforgot">I forgot my password</a></span>
                            </div>
                            <div className="join-offer">
                                <span>Not a member? </span><span>Being outside is not fun</span><br /><a href="/">CLite Now</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default LoginForm;
